module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7592/images/default-avatar.png"